import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppCommonPipesModule } from '../app-common-pipes/app-common-pipes.module';
import { PeopleModule } from '../components/people/people.module';

import { FormsModule }    from '@angular/forms';
import { EditCompetitionEntriesComponent } from '../components/edit-competition-entries/edit-competition-entries.component';
import { EditPayeeComponent } from '../components/edit-payee/edit-payee.component';
import { ElectronicEntrySignatureComponent } from '../components/electronic-entry-signature/electronic-entry-signature.component';
import { BraintreeChoosePaymentMethodComponent } from '../components/braintree/braintree-choose-payment-method/braintree-choose-payment-method.component';
import { BraintreeAddCustomerComponent } from '../components/braintree/braintree-add-customer/braintree-add-customer.component';
import { ModalAddCreditCardComponent } from '../components/braintree/modal-add-credit-card/modal-add-credit-card.component';
import { ArenaPickerComponent } from '../components/arena-picker/arena-picker.component';
import { StripeChoosePaymentMethodComponent } from '../components/stripe/stripe-choose-payment-method/stripe-choose-payment-method.component';
import { StripeModalAddCreditCardComponent } from '../components/stripe/stripe-modal-add-credit-card/stripe-modal-add-credit-card.component';
import { StripeAddCustomerComponent } from '../components/stripe/stripe-add-customer/stripe-add-customer.component';
import { BamboraChoosePaymentMethodComponent } from '../components/bambora/bambora-choose-payment-method/bambora-choose-payment-method.component';
import { BamboraModalAddPaymentMethodComponent } from '../components/bambora/bambora-modal-add-payment-method/bambora-modal-add-payment-method.component';
import { PhoneRegexDirective } from '../validators/phone-regex.directive';
import {GoogleMapsAddressCompleteComponent} from '../components/google-maps-address-complete/google-maps-address-complete.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        AppCommonPipesModule,
        FontAwesomeModule,
        PeopleModule,
        PhoneRegexDirective,
        GoogleMapsAddressCompleteComponent
    ],
  declarations: [EditCompetitionEntriesComponent,
  	EditPayeeComponent,
  	ElectronicEntrySignatureComponent,
    BraintreeChoosePaymentMethodComponent,
    BraintreeAddCustomerComponent,
    ModalAddCreditCardComponent,
    ArenaPickerComponent,
    StripeChoosePaymentMethodComponent,
    StripeModalAddCreditCardComponent,
    StripeAddCustomerComponent,
    BamboraChoosePaymentMethodComponent,
    BamboraModalAddPaymentMethodComponent
  ],
  exports: [
    EditCompetitionEntriesComponent,
    ElectronicEntrySignatureComponent,
    EditPayeeComponent,
    BraintreeChoosePaymentMethodComponent,
    BraintreeAddCustomerComponent,
    ModalAddCreditCardComponent,
    ArenaPickerComponent,
    StripeChoosePaymentMethodComponent,
    StripeModalAddCreditCardComponent,
    StripeAddCustomerComponent,
    BamboraChoosePaymentMethodComponent,
    BamboraModalAddPaymentMethodComponent,
    PhoneRegexDirective
  ]
})
export class SmsSharedModule { }
